<template>
  <div class="app-container">
    <div :class="{'flex-box' : isHorizontal}">
      <div class="info_img">
        <img :src="require(`@/assets/img/${theme[2].imgUrl}/Syg_icon_tuis.png`)">
      </div>
      <div class="btn-box">
        <a class="a-btn" :style="`color: ${themeConfig.dark}; border-color: ${themeConfig.dark}`" :href="init.official_website">进入官网</a>
      </div>
    </div>
    <div v-if="!isHorizontal">
      <p class="wx-p" :style="`color: ${themeConfig.dark};`">官方微信公众号：{{init.wechat_account_name}}</p>
      <p class="tips">【长按保存二维码】</p>
      <div class="qrcode">
        <img :src="init.wechat_account_qrcode">
      </div>
      <div class="last-p">
        <p>搜索公众号:<span>{{init.wechat_account}}</span></p>
        <p>在微信中识别二维码，海量礼包等你拿</p>
      </div>
    </div>
    <div class="flex-bot" v-else>
      <div>
        <div class="qrcode">
          <img :src="init.wechat_account_qrcode">
        </div>
        <p class="tips">【长按保存二维码】</p>
      </div>
      <div class="right-box">
        <p class="wx-p">官方微信公众号：<span :style="`color: ${themeConfig.dark};`">{{init.wechat_account_name}}</span></p>
        <div class="last-p">
          <p>搜索公众号:<span>{{init.wechat_account}}</span></p>
          <p>在微信中识别二维码，海量礼包等你拿</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Information',
  computed: {
    ...mapGetters([
      'themeConfig',
      'isHorizontal',
      'theme',
      'init'
    ])
  }
}
</script>

<style lang="less" scoped>
.app-container {
  overflow: hidden;
}
.info_img {
  margin: .6rem auto .12rem;
  width: 2rem;
  img {
    display: block;
    width: 100%;
  }
}
.a-btn {
  display: block;
  border: 1.45px solid;
  border-radius: .1rem;
  font-size: .24rem;
  line-height: .7rem;
  width: 2.3rem;
  text-align: center;
  margin: 0.2rem auto;
}
.wx-p {
  text-align: center;
  font-size: .18rem;
  line-height: .36rem;
}
.tips {
  text-align: center;
  color: #a8a8a8;
  font-size: .18rem;
  line-height: .36rem;
}
.qrcode {
  width: 1.76rem;
  margin: .15rem auto;
  img {
    display: block;
    width: 100%;
  }
}
.last-p {
  text-align: center;
  font-size: .18rem;
  line-height: .3rem;
  color: #a8a8a8;
  span {
    color: #333;
  }
}
.flex-box {
  display: flex;
  align-items: center;
  padding: 0 .3rem 0 0;
}
.flex-bot {
  display: flex;
  align-items: center;
  justify-content:space-around;
  .right-box {
    width: 45%;
    .wx-p, .last-p {
      text-align: left;
      font-size: .22rem;
      line-height: .3rem;
    }
    .wx-p {
      margin-bottom: .3rem;
      span {
        display: block;
      }
    }
  }
}
</style>
